import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Grid, Chip } from "@material-ui/core";
import styles from "../setting.module.css";
import Avatar from "@mui/material/Avatar";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import useAxiosPrivate from "../../../utils/hooks/useAxiosPrivate";

export default function CoachManagementModalForAdmin(props) {
  const { data, loadData, setDisplayMessage } = props;
  const axios = useAxiosPrivate();
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });

  const handleClose = () => {
    setAlert({
      showAlert: false,
      severity: "success",
      message: "",
    });
  };

  const submitAction = async (e) => {
    try {
      let newRole;
      if (e.action === "PHYSICIAN") {
        newRole = "USER_PHYSICIAN";
      } else if (e.action === "TECHNICIAN") {
        newRole = "USER_TECHNICIAN";
      } else {
        newRole = e?.role === "USER" ? "ADMIN" : "USER";
      }

      const { data } = await axios.post("/team/change_role", {
        user_id: e?.id,
        role: newRole,
      });
      if (data?.status === "OK") {
        setAlert({
          showAlert: true,
          severity: "success",
          message: data?.message,
        });

        if (newRole === "ADMIN") {
          setDisplayMessage({
            show: true,
            message: `${e.first_name ?? "-"} ${
              e.last_name ?? "-"
            } has been upgraded to Admin.`,
          });
        } else {
          setDisplayMessage({
            show: true,
            message: `${e.first_name ?? "-"} ${
              e.last_name ?? "-"
            } has been Changed to ${newRole}.`,
          });
        }
      }
      loadData();
    } catch (error) {
      if (error.response && error.response?.data) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: error.response?.data?.message,
        });
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Something error!",
        });
      }
    }
  };

  return (
    <>
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid container style={{ width: "55.5rem" }}>
          <Grid
            item
            md={3}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <p className={styles.tittleText}>Name</p>
          </Grid>
          <Grid
            item
            md={4}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <p className={styles.tittleText}>Email</p>
          </Grid>
          <Grid
            item
            md={2}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <p className={styles.tittleText}>Level</p>
          </Grid>
          <Grid
            item
            md={3}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <p className={styles.tittleText}>Operation</p>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box className={styles.boxCSSForAdmin}>
          {data.map((item) => (
            <>
              <Grid container style={{ marginTop: "1rem" }}>
                <Grid
                  item
                  md={1}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    alt="Rem_Sharp"
                    src={item.avatar_url}
                    sx={{ width: 35, height: 35 }}
                  />
                </Grid>
                <Grid
                  item
                  md={2}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Grid container>
                    <Grid
                      item
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-end",
                      }}
                    >
                      <p className={styles.tittleTextData1}>
                        {item?.first_name ?? "-"}
                      </p>
                    </Grid>
                    <Grid
                      item
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      }}
                    >
                      <p className={styles.tittleTextData2}>
                        {item?.last_name}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  md={4}
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <p className={styles.tittleTextData}>{item?.email}</p>
                </Grid>
                <Grid
                  item
                  md={2}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Chip
                    label={
                      item?.role === "SUPER_ADMIN"
                        ? "Super Admin"
                        : item?.role === "ADMIN"
                        ? "Admin"
                        : item?.role === "USER_PHYSICIAN"
                        ? "Physician"
                        : item?.role === "USER_TECHNICIAN"
                        ? "Technician"
                        : "User"
                    }
                    size="small"
                    style={{
                      backgroundColor: "#A6DCE5",
                      padding: "0.5rem 0.5rem 0.5rem 0.5rem",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  {item?.role === "ADMIN" ? (
                    <p
                      className={styles.tittleTextOperation}
                      onClick={() => submitAction(item)}
                    >
                      Downgrade to User
                    </p>
                  ) : item?.role === "USER" ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <p
                        className={styles.tittleTextOperation}
                        onClick={() => submitAction(item)}
                      >
                        Upgrade to Admin
                      </p>
                      <p
                        className={styles.tittleTextOperation}
                        onClick={() =>
                          submitAction({ ...item, action: "PHYSICIAN" })
                        }
                      >
                        Change to Physician
                      </p>
                      <p
                        className={styles.tittleTextOperation}
                        onClick={() =>
                          submitAction({ ...item, action: "TECHNICIAN" })
                        }
                      >
                        Change to Technician
                      </p>
                    </div>
                  ) : null}
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "1rem" }}>
                <Grid item md={12}>
                  <hr style={{ border: "0.1px solid #A6DCE5" }} />
                </Grid>
              </Grid>
            </>
          ))}
        </Box>
        <Snackbar
          open={alert.showAlert}
          autoHideDuration={4000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity={alert.severity} onClose={handleClose}>
            {alert.message}
          </Alert>
        </Snackbar>
      </Grid>
    </>
  );
}
